import { Box, Input, SwipeableDrawer } from "@mui/material";
import React, { Fragment, useState } from "react";
import "dayjs/locale/vi";

const AdvancedFilter = (props) => {
  const {
    openAdvancedFilter,
    handleOpenAdvancedFilter,
    handleCloseAdvancedFilter,
    filter,
    setFilter,
    checkV2,
    setCheckV2,
  } = props;

  const handleChangeKeyword = (keyword) => {
    setFilter({
      ...filter,
      title: keyword.target.value.trim(),
      value: keyword.target.value,
    });
  };

  const [signer, setSigner] = useState("");

  const handleChangeSigner = (signer) => {
    setSigner(signer?.target.value || null);
    setFilter({
      ...filter,
      signer: signer?.target.value.trim() || null,
    });
  };

  const handleApply = () => {
    setFilter({ ...filter, page: 0, size: 10 });
    handleCloseAdvancedFilter();
  };

  const handleReset = () => {
    setFilter({
      ...filter,
      title: "",
      signer: "",
      value: "",
    });
    setSigner("");
    setCheckV2(!checkV2);
  };

  const list = (
    <>
      <Box
        sx={{
          width: "335px",
          pt: "50px",
          minHeight: "500px",
          "& ul": {
            position: "unset",
            marginBottom: "70px",
          },
        }}
        role="presentation"
      >
        <div className="px-5 mt-[50px]">
          <div className="min-h-[calc(100vh-90px)]">
            <p className="font-semibold text-sm leading-5 text-[#16192C] mb-2">
              Tìm kiếm
            </p>
            <Input
              className="h-[56px] w-full border border-blue-400 rounded-md px-2"
              placeholder=" Tìm kiếm theo trích yếu / số hiệu"
              type="search"
              value={filter?.value}
              onChange={handleChangeKeyword}
              disableUnderline
            />
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-2">
              Người ký
            </p>
            <Input
              className="h-[56px] w-full border border-blue-400 rounded-md px-2"
              placeholder=" Tìm kiếm theo người ký"
              type="search"
              value={filter.signer}
              onChange={handleChangeSigner}
              disableUnderline
            />
          </div>
        </div>
      </Box>
      <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
        <button
          onClick={handleReset}
          className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Nhập lại
          </div>
        </button>
        <button
          onClick={handleApply}
          className="text-center w-1/2 border-[1px] block text-white rounded bg-primary py-[12px] ml-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Áp dụng
          </div>
        </button>
      </div>
    </>
  );
  return (
    <Fragment>
      <SwipeableDrawer
        anchor={"right"}
        open={openAdvancedFilter}
        onOpen={handleOpenAdvancedFilter}
        onClose={handleCloseAdvancedFilter}
        disableSwipeToOpen={false}
      >
        {list}
      </SwipeableDrawer>
    </Fragment>
  );
};

export default AdvancedFilter;
